import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { cn } from "@/lib/utils";
import TutorSheet from "./TutorSheet";

// Routes where the tutor FAB should NOT render. Admin pages have their own
// dense layouts and the tutor isn't useful there. Shared/public artifact
// pages (read-only) are skipped to keep them clean for screenshots/embeds.
const HIDDEN_PREFIXES = ["/admin", "/cert/"];

export default function AskTutorFAB() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Close the sheet automatically on route change so it never lingers
  // over an unrelated page.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const hidden = HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p));
  if (hidden) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Ask the tutor"
        className={cn(
          // Position above ReportBugButton (bottom-right) and above mobile bottom nav.
          "fixed bottom-20 right-4 z-40 sm:bottom-24 sm:right-6",
          "group flex items-center gap-2 rounded-full",
          "border border-primary/30 bg-background/90 px-3 py-2 shadow-lg backdrop-blur",
          "text-sm font-medium text-foreground",
          "transition-all hover:scale-105 hover:border-primary hover:bg-primary hover:text-primary-foreground",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        )}
      >
        <span className="grid h-7 w-7 place-items-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary-foreground/20 group-hover:text-primary-foreground">
          <GraduationCap className="h-4 w-4" />
        </span>
        <span className="hidden pr-1 sm:inline">Tutor</span>
      </button>
      <TutorSheet open={open} onOpenChange={setOpen} />
    </>
  );
}